import { defineMessages, MessageDescriptor } from 'react-intl';

export type TargetMessages = {
  learnLanguage: MessageDescriptor;
};

export const ar: TargetMessages = defineMessages({
  learnLanguage: {
    id: 'seo_learn_page_breadcrumb_ar',
  },
});

export const da: TargetMessages = defineMessages({
  learnLanguage: {
    id: 'seo_learn_page_breadcrumb_da',
  },
});

export const de: TargetMessages = defineMessages({
  learnLanguage: {
    id: 'seo_learn_page_breadcrumb_de',
  },
});

export const el: TargetMessages = defineMessages({
  learnLanguage: {
    id: 'seo_learn_page_breadcrumb_el',
  },
});

export const en: TargetMessages = defineMessages({
  learnLanguage: {
    id: 'seo_learn_page_breadcrumb_en',
  },
});

export const es: TargetMessages = defineMessages({
  learnLanguage: {
    id: 'seo_learn_page_breadcrumb_es',
  },
});

export const fa: TargetMessages = defineMessages({
  learnLanguage: {
    id: 'seo_learn_page_breadcrumb_fa',
  },
});

export const fr: TargetMessages = defineMessages({
  learnLanguage: {
    id: 'seo_learn_page_breadcrumb_fr',
  },
});

export const he: TargetMessages = defineMessages({
  learnLanguage: {
    id: 'seo_learn_page_breadcrumb_he',
  },
});

export const hi: TargetMessages = defineMessages({
  learnLanguage: {
    id: 'seo_learn_page_breadcrumb_hi',
  },
});

export const id: TargetMessages = defineMessages({
  learnLanguage: {
    id: 'seo_learn_page_breadcrumb_id',
  },
});

export const is: TargetMessages = defineMessages({
  learnLanguage: {
    id: 'seo_learn_page_breadcrumb_is',
  },
});

export const it: TargetMessages = defineMessages({
  learnLanguage: {
    id: 'seo_learn_page_breadcrumb_it',
  },
});

export const jp: TargetMessages = defineMessages({
  learnLanguage: {
    id: 'seo_learn_page_breadcrumb_jp_full',
  },
});

export const ko: TargetMessages = defineMessages({
  learnLanguage: {
    id: 'seo_learn_page_breadcrumb_ko',
  },
});

export const mn: TargetMessages = defineMessages({
  learnLanguage: {
    id: 'seo_learn_page_breadcrumb_mn',
  },
});

export const nl: TargetMessages = defineMessages({
  learnLanguage: {
    id: 'seo_learn_page_breadcrumb_nl',
  },
});

export const no: TargetMessages = defineMessages({
  learnLanguage: {
    id: 'seo_learn_page_breadcrumb_no',
  },
});

export const pl: TargetMessages = defineMessages({
  learnLanguage: {
    id: 'seo_learn_page_breadcrumb_pl',
  },
});

export const pt: TargetMessages = defineMessages({
  learnLanguage: {
    id: 'seo_learn_page_breadcrumb_pt',
  },
});

export const ru: TargetMessages = defineMessages({
  learnLanguage: {
    id: 'seo_learn_page_breadcrumb_ru',
  },
});

export const sl: TargetMessages = defineMessages({
  learnLanguage: {
    id: 'seo_learn_page_breadcrumb_sl',
  },
});

export const sv: TargetMessages = defineMessages({
  learnLanguage: {
    id: 'seo_learn_page_breadcrumb_sv',
  },
});

export const sw: TargetMessages = defineMessages({
  learnLanguage: {
    id: 'seo_learn_page_breadcrumb_sw',
  },
});

export const th: TargetMessages = defineMessages({
  learnLanguage: {
    id: 'seo_learn_page_breadcrumb_th',
  },
});

export const tr: TargetMessages = defineMessages({
  learnLanguage: {
    id: 'seo_learn_page_breadcrumb_tr',
  },
});

export const uk: TargetMessages = defineMessages({
  learnLanguage: {
    id: 'seo_learn_page_breadcrumb_uk',
  },
});

export const yo: TargetMessages = defineMessages({
  learnLanguage: {
    id: 'seo_learn_page_breadcrumb_yo',
  },
});

export const zh: TargetMessages = defineMessages({
  learnLanguage: {
    id: 'seo_learn_page_breadcrumb_zh_cn',
  },
});
